import { ContentBlockMap } from 'src/models/Content/PlaceholderKey'

export interface CustomRouteMeta {
  'content-block'?: ContentBlockMap
}

export enum RouteName {
  ROOT = 'root',
  HOME = 'home',
  EVENT = 'book_event',
  LOCATION = 'book_locker',
  RENTAL = 'rental',
  RENTAL_DURATION = 'rental_duration',
  RENTAL_LOCKER_TYPE = 'rental_locker_type',
  RESERVATION = 'reservation',
  RESERVATION_DURATION = 'reservation_duration',
  RESERVATION_LOCKER_TYPE = 'reservation_locker_type',
  RESERVATION_PICKUP = 'reservation_pickup',
  CART = 'cart',
  CHECKOUT = 'checkout',
  PAYMENT_VERIFICATION = 'payment_verification',
  ORDER_OVERVIEW = 'order_overview',
  RENTAL_DETAIL = 'rental_detail',
  RESERVATION_DETAIL = 'reservation_detail',
  MY_ORDERS = 'my_orders',
  SERVICE_UNAVAILABLE = 'service_unavailable',
  NOT_FOUND = 'not_found',
  DEMO = 'demo',
}

export type RouteOption = {
  path: string
}

export type RoutesMap = {
  [K in RouteName]: RouteOption
}

export const ROUTES: RoutesMap = {
  [RouteName.ROOT]: {
    path: '/',
  },
  [RouteName.HOME]: {
    path: '',
  },
  [RouteName.EVENT]: {
    path: 'event/:eventId?',
  },
  [RouteName.LOCATION]: {
    path: 'event/:eventId/location/:locationId?',
  },
  [RouteName.RENTAL]: {
    path: 'event/:eventId/location/:locationId/rental/duration',
  },
  [RouteName.RENTAL_DURATION]: {
    path: ':durationKey?',
  },
  [RouteName.RENTAL_LOCKER_TYPE]: {
    path: ':durationKey/locker/:lockerTypeId?',
  },
  [RouteName.RENTAL_DETAIL]: {
    path: 'rental/:orderToken/:orderItemId',
  },
  [RouteName.RESERVATION]: {
    path: 'event/:eventId/location/:locationId/reservation/duration',
  },
  [RouteName.RESERVATION_DURATION]: {
    path: ':durationStartDate?/:durationEndDate?',
  },
  [RouteName.RESERVATION_LOCKER_TYPE]: {
    path: ':durationStartDate/:durationEndDate/locker/:lockerTypeId?',
  },
  [RouteName.RESERVATION_DETAIL]: {
    path: 'reservation/:orderToken/:orderItemId',
  },
  [RouteName.RESERVATION_PICKUP]: {
    path: 'reservation/pickup',
  },
  [RouteName.CART]: {
    path: 'cart',
  },
  [RouteName.CHECKOUT]: {
    path: 'checkout',
  },
  [RouteName.PAYMENT_VERIFICATION]: {
    path: 'payment/:paymentToken/:status(success|cancel)',
  },
  [RouteName.ORDER_OVERVIEW]: {
    path: 'order/:orderToken',
  },
  [RouteName.MY_ORDERS]: {
    path: 'my-orders',
  },
  [RouteName.SERVICE_UNAVAILABLE]: {
    path: '/service-unavailable',
  },
  [RouteName.NOT_FOUND]: {
    path: '/:catchAll(.*)*',
  },
  [RouteName.DEMO]: {
    path: 'demo',
  },
}
